import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'

import './style.css'
import ScrollToTop from './components/scroll-to-top'
import Sample from './views/sample'
import Home from './views/home'
import About from './views/about'
import Projects from './views/projects'
import Articles from './views/articles'
import ArticleDetail from './views/article-detail'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/sample" element={<Sample />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles/:slug" element={<ArticleDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  )
}

const container = document.getElementById('app')

const root = createRoot(container)
root.render(<App />)
